<template>
    <div class="FiltersAndSorting">
        <div class="FiltersAndSorting__filters">
            <Filters />
        </div>
        <div class="FiltersAndSorting__sorting">
            <Sorting />
        </div>
    </div>
</template>

<script>


import Filters from "@/components/Filters";
import Sorting from "@/components/Sorting";

export default {
    name: "FiltersAndSorting",
    components: {
        Sorting,
        Filters,
    }
}
</script>

<style lang="scss">
.FiltersAndSorting {
  display: flex;
  align-items: center;

  &__filters {
    margin-right: 24px;

    @include mobile {
      margin-right: 12px;
    }
  }
}
</style>